interface RequestParams {
  url: string;
  method: 'POST' | 'GET';
  headers?: Headers;
  body?: Object;
}

const request = async ({ url, method, headers = new Headers(), body }: RequestParams) => {
  headers.append('FFF-Auth', 'V1.1');
  const response = await fetch(url, {
    method,
    mode: 'cors',
    headers,
    credentials: 'include',
    body: JSON.stringify(body),
  });
  const parsedResponse = await response.json();
  if (!response.ok) throw parsedResponse;
  return parsedResponse;
};

export default request;
